import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVendorOutStandingReportData, getVendorOutStandingReportInnerData } from '../../api/ReportsAPI/vendorOutStandingReportAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchVendorOutStandingReport = createAsyncThunk('vendorOutStandingReport/fetchReport', async (params, { rejectWithValue }) => {
    try { const res = await getVendorOutStandingReportData(params); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch vendor outstanding report')); }
});

export const fetchVendorOutStandingDetail = createAsyncThunk('vendorOutStandingReport/fetchDetail', async (params, { rejectWithValue }) => {
    try { const res = await getVendorOutStandingReportInnerData(params); return res?.Data || []; }
    catch (e) { return rejectWithValue(err(e, 'Failed to fetch invoice detail')); }
});

const initialState = {
    report: [], reportLoading: false, reportError: null,
    detail: [], detailLoading: false, detailError: null,
};

const vendorOutStandingReportSlice = createSlice({
    name: 'vendorOutStandingReport',
    initialState,
    reducers: {
        clearVendorOutStandingReport: (s) => { s.report = []; s.reportError = null; },
        clearVendorOutStandingDetail: (s) => { s.detail = []; s.detailError = null; },
        resetVendorOutStandingReport: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVendorOutStandingReport.pending, (s) => { s.reportLoading = true; s.reportError = null; })
            .addCase(fetchVendorOutStandingReport.fulfilled, (s, a) => { s.reportLoading = false; s.report = a.payload; })
            .addCase(fetchVendorOutStandingReport.rejected, (s, a) => { s.reportLoading = false; s.reportError = a.payload; s.report = []; });

        builder
            .addCase(fetchVendorOutStandingDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; })
            .addCase(fetchVendorOutStandingDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = a.payload; })
            .addCase(fetchVendorOutStandingDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = []; });
    },
});

export const {
    clearVendorOutStandingReport, clearVendorOutStandingDetail, resetVendorOutStandingReport,
} = vendorOutStandingReportSlice.actions;

export const selectVOSReport          = (s) => s.vendorOutStandingReport.report;
export const selectVOSReportLoading   = (s) => s.vendorOutStandingReport.reportLoading;
export const selectVOSReportError     = (s) => s.vendorOutStandingReport.reportError;
export const selectVOSDetail          = (s) => s.vendorOutStandingReport.detail;
export const selectVOSDetailLoading   = (s) => s.vendorOutStandingReport.detailLoading;

export default vendorOutStandingReportSlice.reducer;
